import { GridColDef } from "@mui/x-data-grid-pro";
import { defaultFormatCurrency } from "./utils";

export function getLifecycleEventDetailsColumns(
  formatCurrency: (value: number) => string = defaultFormatCurrency,
  // SHI PO is internal-only; opt in from Customer Success, never Customer Experience.
  includeShiPoNumber = false,
  includeGm = false,
): GridColDef[] {
  return [
    {
      field: "manufacturerPartNumber",
      headerName: "Mfg Part #",
      width: 150,
    },
    {
      field: "productDescription",
      headerName: "Product Description",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "serialNumber",
      headerName: "Serial #",
      width: 140,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 110,
      type: "number",
      headerAlign: "center",
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
    },
    {
      field: "eventDate",
      headerName: "Event Date",
      width: 160,
      type: "date",
      valueFormatter: (value) => {
        if (!value) return "";
        return String(value);
      },
    },
    {
      field: "poNumber",
      headerName: "PO #",
      width: 120,
    },
    ...(includeShiPoNumber
      ? [
          {
            field: "shiPoNumber",
            headerName: "SHI PO #",
            width: 130,
          },
        ]
      : []),
    {
      field: "soNumber",
      headerName: "SO #",
      width: 100,
    },
    {
      field: "contractNumber",
      headerName: "Contract #",
      width: 145,
    },
    {
      field: "agreementNumber",
      headerName: "Agreement Number",
      width: 150,
    },
    {
      field: "previousPurchaseCost",
      headerName: "Prev. Cost",
      type: "number",
      valueFormatter: (value) => {
        if (value == null) return "--";
        return formatCurrency(value as number);
      },
    },
    ...(includeGm
      ? [
          {
            field: "gm",
            headerName: "GM",
            type: "number" as const,
            valueFormatter: (value: unknown) => {
              if (value == null) return "--";
              return formatCurrency(value as number);
            },
          },
        ]
      : []),
  ];
}
